import React, { useEffect, useState } from "react";
import { errorNotification } from "../Generic/Notifications";
import { Table, Tbody, Tcol, Thead, Trow } from "../Generic/Table";
import EmptyState from "../Generic/EmptyState";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { beautifyKey } from "../util/util";
import Loader from "../Generic/Loader";
import Button from "../Generic/Button";
import RepenishmentPlanService from "./Services/ReplenishmentPlanService";
import { GOOGLE_DRIVE_FOLDER_URL } from "./ReplnishmentPlanConstants";

const Page = styled.div`
	display: flex;
	height: max-content;
	overflow-y: auto;
	overflow-x: hidden;
	flex-direction: column;
	text-align: left;
	width: 100%;
	padding: 1rem;
`;

const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 2rem;
	font-weight: 600;
	margin: 1rem 0 0 0.5rem;
`;

const CenteredContainer = styled.div`
	width: 100%;
	height: max-content;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: ${(props) => props.margin};
`;

const ViewButton = styled(Button)`
	padding: 0.5rem 1rem;
	font-size: 0.875rem;
	cursor: pointer;
`;

function dateToString(date) {
	return new Date(date).toLocaleString();
}

const PastTasks = (props) => {

	const { activeRole, machineID } = props;

	const [taskList, setTaskList] = useState([]);
	const [loading, setLoading] = useState(true);

	async function getReplenishmentPlans() {
		const payload = {
			statuses: [4, 5, 6, 7],
			restaurantId: machineID
		}
		setLoading(true);
		const response = await RepenishmentPlanService.getReplenishmentPlans(payload, activeRole);
		setLoading(false);
		const { data, error } = response;
		if (data) {
			setTaskList(data);
		}
		if (error) {
			errorNotification(error);
			console.log(error);
		}
	}

	function handleViewDriveFolder() {
		window.open(GOOGLE_DRIVE_FOLDER_URL, '_blank', 'noopener,noreferrer');
	}

	function renderTaskList(tasks) {
		if (tasks.length) {
		let tasksRenderData = tasks.map((task) => {
			const { id, startTime, endTime, type, taskName, inventoryPlan, status, assignee } = task;
			const endTimeString = endTime ? dateToString(endTime) : "-";
			const startTimeString = startTime ? dateToString(startTime) : "-";
			return (
				<Trow key={id}>
					<Tcol borderRadius="10px 0 0 10px" >{id}</Tcol>
					<Tcol>{startTimeString}</Tcol>
					<Tcol>{endTimeString}</Tcol>
					<Tcol>{taskName}</Tcol>
					<Tcol>{assignee}</Tcol>
					<Tcol>{inventoryPlan?.name || "-"}</Tcol>
					<Tcol borderRadius="0 10px 10px 0">{status}</Tcol>
				</Trow>
			);
		});
		return (
			<Table>
				<Trow head>
					<Thead>ID</Thead>
					<Thead>Start Time</Thead>
					<Thead>End Time</Thead>
					<Thead>Type</Thead>
					<Thead>Assigned To</Thead>
					<Thead>Plan Name</Thead>
					<Thead>Status</Thead>
				</Trow>
				<Tbody>
					{tasksRenderData}
				</Tbody>
			</Table>
		);
		} else {
			return <EmptyState retry={getReplenishmentPlans} />
		}
	}

	useEffect(() => {
		getReplenishmentPlans();
	}, []);

	return (
		<Page>
			<Header>
				<span>Past Tasks</span>
				<ViewButton onClick={handleViewDriveFolder}>
					View Images
				</ViewButton>
			</Header>
			{!loading ? renderTaskList(taskList) : ""}
			{loading ? (
				<CenteredContainer>
					<Loader />
				</CenteredContainer>
			) : (
				""
			)}
		</Page>
	);
};

const mapStateToProps = (state) => {
	const { task, landing } = state;
	return { ...task, ...landing };
};

const mapDispatchToProps = (dispatch) => ({
	...bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PastTasks);
